import styled from '@emotion/styled';
import React,{useContext} from 'react';
import { FaTimes as CancelIcon } from 'react-icons/fa';
import { ApplicantContext } from '../Applicants';

const sample = '/sample-template.png';
const TemplateSample = () => {
  const {setShowModal,setShowTemplate} = useContext(ApplicantContext);
  const handleClick = () =>{
    setShowModal(false);
    setShowTemplate(false);
  }
  return (
    <Wrapper>
        <span onClick={handleClick}>
          <CancelIcon />
        </span>
        <div>
          Please make sure the file you upload follows this format.
        </div>
        <img src={sample} alt="template sample" />
    </Wrapper>
  )
}

export default TemplateSample;



const Wrapper = styled.div`
    width:700px;
    height: fit-content;
    display:flex;
    top:50px;
    padding:20px;
    flex-direction: column;
    gap:5px;
    justify-content: center;
    align-items:center;
    position: relative;
    background-color: var(--white-color);
    border-radius: 15px;;
    & span{
      position:absolute;
      top:0px;
      right:-50px;
      width:45px;
      height:45px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color:rgba(255,255,255,0.2);
      color:var(--white-color);
      font-size:30px;
      cursor:pointer;
    }
    & > div{
      text-align: center;
      color:red;
    }
    & > img{
        width:100%;
        height:auto;
        object-fit:contain;
        border:1px solid lightgray;
    }
    & > *:not(span){
      width:100%;
    }
`